export default {
  zipCodeCountries: new Set(["United States", "Canada", "Puerto Rico", "Guam", "US Virgin Islands"])
};
